import $ from 'zzc-zepto';

const $window = $(window);

function updateViewportWidth() {
  return $window.width();
}

function updateViewportHeight() {
  return $window.height();
}
let viewportWidth = updateViewportWidth();
let viewportHeight = updateViewportHeight();

$window.on('resize', () => {
  viewportWidth = updateViewportWidth();
  viewportHeight = updateViewportHeight();
});
export function getViewportWidth() {
  return viewportWidth;
}
export function getViewportHeight() {
  return viewportHeight;
}
